export default __webpack_public_path__ + "static/media/shock_treatment.699ce92f.jpg";